import { getFunctions, httpsCallable } from 'firebase/functions';
import app from '../firebase/config';

export interface TestSendRequest {
  subject: string;
  html: string;
  text: string;
  /** From address to send the test as; validated against the allowlist server-side. */
  fromEmail: string;
  fromName: string;
  /** Reply-To for the test; defaults to the caller if empty or not permitted. */
  replyTo: string;
  sampleMergeData?: Record<string, string>;
}

export interface TestSendResult {
  messageId: string;
  to: string;
  /** False when the From line fell back to the default sending address. */
  sentAsSelf: boolean;
}

const functions = getFunctions(app, 'us-central1');

/**
 * Sends one copy of the draft to the signed-in user. The destination is chosen
 * server-side from the auth token, so there is nothing to pass here.
 */
export async function sendTestToSelf(request: TestSendRequest): Promise<TestSendResult> {
  const callable = httpsCallable<TestSendRequest, TestSendResult>(functions, 'sendTestToSelf');
  const response = await callable(request);
  return response.data;
}
